angular.module('unergie.main')
.controller('metaInvoicesB2GPreliminaryCtrl', ($scope, NgTableParams, FilterMapping, SocketFactory, MetaPreliminaryAPI, DataAccess, DownloadService,
    AlertManager, Sequentializer, TableGeneratorService, ApiBilling, ErrorCatcher) => {
    $scope.invoiceStatuses = FilterMapping.invoiceStatuses
    $scope.metaInvoiceTypes = FilterMapping.metaInvoiceTypes

    $scope.fetchingAccounts = true

    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]

    SocketFactory.join('BO_metaInvoicesB2GPreliminary', $scope)


    $scope.boolFilter = [{ id: true, title: 'Oui' }, { id: false, title: 'Non' }]

    $scope.metaInvoices = {
        refreshing: false,
        show: {},
        counts: [10, 25, 50, 100],
        columns: {
            'selector': { label: 'Sel.', mode: 'filter_only' },
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'category.organization': { label: 'Org.', mode: 'search_wildcard' },
            'id_category': { label: 'ID Paquet', mode: 'search_operator', mandatory: true },
            'category.name': { label: 'Paquet facturier', mode: 'search_wildcard', translateCsv: 'paquet_facturier' },
            'type': { label: 'Type', mode: 'search_wildcard' },
            'status': { label: 'Status', mode: 'search_operator', translateCsv: 'statut' },
            'category.account.brand': { label: 'Compte', mode: 'search_wildcard', translateCsv: 'compte' },
            'invoice_date': { label: 'Date Facture', mode: 'search_date', translateCsv: 'date_creation' },
            'period_start_date': { label: 'Début', mode: 'search_date', translateCsv: 'date_debut_periode' },
            'period_end_date': { label: 'Fin', mode: 'search_date', translateCsv: 'date_fin_periode' },
            'preparation_result': { label: 'Résultats intermédiaires', mode: 'hidden' },
            'error_code': { label: 'Code erreur', mode: 'search_wildcard' },
        },
    }

    $scope.cancellable = (invoice) => [0, 1, 11, 12, 20, 21, 40, 501, 90, 91, 92, 99].includes(invoice.status)
    $scope.valuable = (invoice) => [0, 11, 12, 20, 21, 40, 501, 90, 91, 92, 93, 99].includes(invoice.status)

    $scope.processing = (invoice) => _.some([
        invoice.valuating,
        invoice.cancelling,
        invoice.toggling,
    ])

    $scope.toggleSelected = function (invoice, e) {
        e.preventDefault()
        e.stopPropagation()
        invoice.selected = !invoice.selected
    }

    $scope.selectAll = () =>
        _.forEach($scope.metaInvoices.instance.data, (c) => {
            c.selected = true
        })

    $scope.deSelectAll = () =>
        _.forEach($scope.metaInvoices.instance.data, (c) => {
            c.selected = false
            return true
        })

    $scope.getValuables = () =>
        _.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.valuable(i))

    $scope.getCancellablesInvoices = () =>
        _.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.cancellable(i))

    $scope.getSelectedNumber = () => _.countBy($scope.metaInvoices.instance.data, 'selected').true || 0

    const fetchMetaInvoiceInvoices = (invoice) => {
        return MetaPreliminaryAPI.fetchMetaPreliminaryInvoices({ id: invoice.id }).$promise.then((result) => {
            invoice.invoiceCount = result.length
            invoice.invoicesTP = new NgTableParams({ count: 12 }, {
                counts: [],
                dataset: result,
            })
        })
        .catch(ErrorCatcher)
    }

    $scope.refreshInvoice = function (i) {
        const refreshes = []
        refreshes.push(fetchMetaInvoiceInvoices(i))
        i.refreshing = true
        return Promise.all(refreshes).then(() => {
            i.fetched = true
            i.refreshing = false
        })
    }

    $scope.toggleExpand = function (invoice) {
        if (!invoice.refreshing) {
            invoice.expanded = !invoice.expanded
            if (!invoice.fetched) {
                $scope.refreshInvoice(invoice)
            }
        }
    }

    // TEST READINGS
    $scope.categoryPayload = {
        id_category: '',
        period_end_date: moment().add(-1, 'month').endOf('month'),
    }

    $scope.categoryFields = {
        id_category: {
            label: 'IDs paquets facturiers (<id1>,<id2>)',
            type: 'text',
        },
        period_end_date: {
            label: 'Date',
            type: 'date',
        },
    }

    // CALLS
    $scope.createMetaForCategory = () => {
        if ($scope.categoryPayload.id_category) {
            $scope.creatingMeta = true
            return MetaPreliminaryAPI.createMetaPreliminary({
                categories: _.map($scope.categoryPayload.id_category.split(','), (id) => Number(id.trim())),
                endDate: moment($scope.categoryPayload.period_end_date).format('YYYY-MM-DD'),
            }).$promise.then((result) => {
                AlertManager.success('Ok')
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.refreshInvoices()
                $scope.creatingMeta = false
            })
        }
    }

    $scope.valuate = (invoice, e, preventRefresh) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }
        if ($scope.processing(invoice)) {
            return
        }
        if ($scope.valuable(invoice)) {
            invoice.valuating = true
            return MetaPreliminaryAPI.valuateMetaPreliminary({ id: invoice.id }, {}).$promise.then((result) => {
                AlertManager.success(`Valorisation lancée`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                invoice.valuating = false
                if (!preventRefresh) {
                    $scope.refreshInvoices()
                }
            })
        }
    }

    $scope.cancelInvoice = (invoice, doNotRefresh = false) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.cancelling = true
        return MetaPreliminaryAPI.cancelMetaPreliminary({ id: invoice.id }).$promise.then((result) => {
            AlertManager.success('Annulation OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.cancelling = false
            if (!doNotRefresh) {
                $scope.refreshInvoices()
            }
        })
    }

    // MASS OPERATIONS

    // MASS VALUATE
    $scope.massValuateTemplate = {
        reprocessAll: false,
    }

    $scope.massValuateFields = {
        reprocessAll: {
            label: 'Relancer toutes les valo. des sous-factures',
            type: 'checkbox',
        },
    }

    $scope.massValuate = () => {
        const invoices = $scope.getValuables()
        if (!invoices.length) {
            return
        }
        $scope.massValuating = true
        return Sequentializer.mapSeries(invoices, (invoice) => $scope.valuate(invoice, null, true))
        .then((result) => {
            console.log(`Mass valuate result`, result)
            AlertManager.success(`Factures revalorisées`)
        })
        .finally(() => {
            $scope.massValuating = false
            $scope.refreshInvoices()
        })
    }

    // MASS CANCEL
    $scope.massCancel = () => {
        const invoices = $scope.getCancellablesInvoices()
        if (!invoices.length) {
            return
        }
        $scope.massCancelling = true
        return Sequentializer.mapSeries(invoices, (invoice) => $scope.cancelInvoice(invoice, true))
        .then((result) => {
            console.log(`Mass cancel result`, result)
            AlertManager.success(`Factures annulées`)
        })
        .finally(() => {
            $scope.massCancelling = false
            $scope.refreshInvoices()
        })
    }

    $scope.fetchAccounts = () => DataAccess.myAccounts({ light: true }).$promise
    .then((accounts) => {
        $scope.csvFields.id.enum = _.map(accounts, (a) => ({ value: a.id, label: `${a.brand} (${a.organization})` }))
    })
    .catch(ErrorCatcher)
    .finally(() => {
        $scope.fetchingAccounts = false
    })

    $scope.csvPayload = {
        id: null,
        startDate: moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
        endDate: moment().startOf('month').format('YYYY-MM-DD'),
        force: false,
    }

    $scope.csvFields = {
        id: {
            label: 'Compte',
            type: 'typeahead',
            size: 45,
            limitTo: 15,
            required: true,
            enum: [],
        },
        startDate: {
            label: 'Date de début',
            required: true,
            type: 'date',
        },
        endDate: {
            label: 'Date de fin',
            required: true,
            type: 'date',
        },
        force: {
            label: 'Forcer',
            type: 'checkbox',
        },
    }

    // DOWNLOAD CSV
    $scope.dlConsolidatedCSV = () => {
        DownloadService.downloadFile(`/api/managed-accounts/${$scope.csvPayload.id}/meta-invoices-preliminary-csv` +
            `?startDate=${$scope.csvPayload.startDate}&endDate=${$scope.csvPayload.endDate}&force=${$scope.csvPayload.force}`)
    }

    $scope.refreshInvoices = () => {
        TableGeneratorService.getTable(
            $scope.metaInvoices,
            'meta-invoices-preliminary',
            `category.account`,
            null,
            {
                orderBy: '-id',
            },
        )
    }

    const activate = () => {
        $scope.fetchAccounts()
        $scope.refreshInvoices()
    }

    activate()

    $scope.getNbMessages = () => {
        ApiBilling.getMessagesNumber().$promise.then((result) => {
            console.log(result)
            $scope.nbMessages = result
        })
        .catch(ErrorCatcher)
    }
    $scope.getNbMessages()
})
